// amenitiesMap.js
export const AMENITIES_MAP = {
  1: "Television",
  4: "Wifi",
  5: "Air Conditioning",
  8: "Kitchen",
  9: "Free Parking On Premises",
  12: "Pets Allowed",
  15: "Gym",
  23: "Free Street Parking",
  25: "Hot Tub",
  27: "Indoor Fireplace",
  30: "Heating",
  33: "Washer",
  34: "Dryer",
  35: "Smoke Alarm",
  37: "First Aid Kit",
  39: "Fire Extinguisher",
  41: "Shampoo",
  44: "Hangers",
  45: "Hair Dryer",
  46: "Iron",
  47: "Dedicated Workspace",
  51: "Self Check-In",
  52: "Smart Lock Entry",
  53: "Keypad Entry",
  54: "Lockbox",
  57: "Private Entrance",
  61: "Bathtub",
  64: "High Chair",
  66: "Children's Books & Toys",
  69: "Fireplace Guards",
  70: "Babysitter Recommendations",
  72: "Crib",
  73: "Room Darkening Shades",
  74: "Children's Dinnerware",
  77: "Hot Water",
  79: "Body Soap",
  85: "Bed Linens",
  87: "Ethernet Connection",
  89: "Microwave",
  90: "Coffee Maker",
  91: "Refrigerator",
  92: "Dishwasher",
  95: "Oven",
  96: "Stove",
  97: "EV Charger",
  98: "Single Level Home",
  99: "BBQ Grill",
  100: "Patio / Balcony",
  101: "Backyard",
  103: "Luggage Drop Off Allowed",
  104: "Long Term Stays Allowed",
  107: "Cleaning Before Checkout",
  129: "Host Greets You",
  132: "Waterfront",
  133: "Lake Access",
  137: "Hot Water Kettle",
  139: "Ceiling Fan",
  146: "Mini Fridge",
  153: "Hammock",
  172: "Kayak",
  179: "Outdoor Dining Area",
  185: "Sound System",
  201: "Bikes",
  219: "Fire Pit",
  223: "Sauna",
  227: "Exercise Equipment",
  236: "Dining Table",
  251: "Toaster",
  258: "Private Pool",
  280: "Outdoor Furniture",
  308: "Freezer",
  322: "Blender",
  392: "Board Games",
  394: "Books & Reading Material",
  415: "Coffee",
  515: "Ping Pong Table",
  521: "Pool Table",
  522: "Portable Fans",
  527: "Record Player",
  611: "Shower Gel",
  626: "BBQ Utensils",
  657: "Conditioner",
  663: "Laundromat Nearby",
  664: "Boat Slip",
  665: "Cleaning Products",
  667: "Drying Rack For Clothing",
  671: "Clothing Storage",
  672: "Wine Glasses",
  674: "Beach Access",
  9999: "Security Cameras On Property",
};

export const AMENITY_EMOJIS = {
  1: "📺", // Television
  4: "🛜", // Wifi
  5: "❄️", // Air Conditioning
  8: "🍳", // Kitchen
  9: "🅿️", // Free Parking
  12: "🐶", // Pets Allowed
  15: "🏋️", // Gym
  23: "🚗", // Free Street Parking
  25: "🛀", // Hot Tub
  27: "🔥", // Indoor Fireplace
  30: "♨️", // Heating
  33: "🧺", // Washer
  34: "🧺", // Dryer
  35: "🚨", // Smoke Alarm
  37: "🩹", // First Aid Kit
  39: "🧯", // Fire Extinguisher
  40: "🧴", // Essentials
  41: "🧴", // Shampoo
  44: "👔", // Hangers
  45: "💇", // Hair Dryer
  46: "🪒", // Iron (closest visual)
  47: "💼", // Dedicated Workspace
  51: "🔑", // Self Check-In
  52: "🔒", // Smart Lock
  53: "🔢", // Keypad
  54: "📦", // Lockbox
  57: "🚪", // Private Entrance
  61: "🛁", // Bathtub
  64: "🪑", // High Chair
  66: "📚", // Children's Books & Toys
  69: "🛡️", // Fireplace Guards
  70: "🧸", // Babysitter Recommendations
  72: "🛏️", // Crib
  73: "🕶️", // Room Darkening Shades
  74: "🍽️", // Children's Dinnerware
  77: "💧", // Hot Water
  79: "🧼", // Body Soap
  85: "🛏️", // Bed Linens
  86: "🛏️", // Extra Pillows & Blankets
  87: "🔌", // Ethernet Connection
  89: "🍽️", // Microwave
  90: "☕", // Coffee Maker
  91: "🧊", // Refrigerator
  92: "🍽️", // Dishwasher
  93: "🍽️", // Plates/Bowls
  94: "🍳", // Pots & Pans
  95: "🍕", // Oven
  96: "🍳", // Stove
  97: "🔌", // EV Charger
  98: "🏠", // Single Level Home
  99: "🔥", // BBQ Grill
  100: "🌅", // Patio / Balcony
  101: "🌳", // Backyard
  102: "🏖️", // Beach Essentials
  103: "🧳", // Luggage Drop Off
  104: "📅", // Long Term Stay
  107: "🧹", // Cleaning Before Checkout
  129: "👋", // Host Greets You
  132: "🌊", // Waterfront
  133: "🏞️", // Lake Access
  137: "☕", // Hot Water Kettle
  139: "🌬️", // Ceiling Fan
  146: "🧊", // Mini Fridge
  153: "🪢", // Hammock
  172: "🛶", // Kayak
  179: "🍽️", // Outdoor Dining
  185: "🔊", // Sound System
  201: "🚲", // Bikes
  219: "🔥", // Fire Pit
  223: "🧖", // Sauna
  227: "🏋️", // Exercise Equipment
  236: "🍽️", // Dining Table
  251: "🍞", // Toaster
  258: "🏊", // Private Pool
  280: "🪑", // Outdoor Furniture
  308: "🧊", // Freezer
  322: "🥤", // Blender
  392: "🎲", // Board Games
  394: "📚", // Books
  415: "☕", // Coffee
  515: "🏓", // Ping Pong
  521: "🎱", // Pool Table
  522: "🌀", // Portable Fans
  527: "📻", // Record Player
  611: "🧴", // Shower Gel
  625: "🧁", // Baking Sheet
  626: "🍽️", // BBQ Utensils
  657: "🧴", // Conditioner
  663: "🧺", // Laundromat Nearby
  664: "🚤", // Boat Slip
  665: "🧼", // Cleaning Products
  667: "🧺", // Drying Rack
  671: "👗", // Clothing Storage
  672: "🍷", // Wine Glasses
  674: "🏖️", // Beach Access
  9999: "📹", // Security Cameras
};
